import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ButtonPrimary } from '../../button';
import Form, {} from '../../form';
import FormBlock from '../../form-block';
import FormFieldCheckbox from '../../form-field-checkbox';
import FormFieldPassword from '../../form-field-password';
import FormFieldUsername from '../../form-field-username';
import FormFooter from '../../form-footer';
import Link from '../../link';
import { List, ListItem } from '../../list';
import Panel from '../../panel';
import Typography from '../../typography';
import { getHost, request } from '../../../utilities/api';
import { getLocalStorage, getWebUrl as getParentWindowHost, removeLocalStorage, setLocalStorage, } from '../../../utilities/browser';
import NotificationError from './NotificationError';
import NotificationIncorrectDetails from './NotificationIncorrectDetails';
import NotificationNoLongerPossible from './NotificationNoLongerPossible';
import NotificationNotActivated from './NotificationNotActivated';
import { parseResponseCode, postMessageLoggedIn } from './utils';
import { LoginInContextContainer } from './styles/login-in-context-application.styled';
export const CLIENT_IDS = {
    'api-ontw': 'DyBUQGfTdd8pGugGY4wvRHmf52A4DN7f',
    'api-test': 'UxS0cmy9KvlKawpxkFtUOBXzCPsDNm74',
    'api-acc': 'ToJnJIr1dvfjxpzGnFzAv1tQCtIZudHx',
    api: 'LPp4IDyFRCl6ii5QPsHMVNTcX2xsHltW',
};
export const LoginInContextApplication = () => {
    const [loading, setLoading] = useState(false);
    const [notificationCode, setNotificationCode] = useState(0);
    const [username, setUsername] = useState(getLocalStorage('sso_username', ''));
    const handleSubmit = (formData) => {
        setNotificationCode(0);
        setLoading(formData.valid);
        if (!formData.valid)
            return;
        const requestConfig = {
            clientId: CLIENT_IDS[getHost()],
            appId: 'SSO-LOGIN-IN-CONTEXT',
        };
        const requestDetails = {
            url: '/v1/auth/login',
            options: {
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify(formData.elementsData),
            },
        };
        request(requestDetails, requestConfig)
            .then((response) => {
            return response.json().then((responseBody) => {
                setUsername(formData.elementsData.username);
                setNotificationCode(parseResponseCode({
                    code: response.status,
                    body: responseBody,
                }));
                setLoading(false);
                if (!formData.elementsData.rememberMe)
                    removeLocalStorage('sso_username');
                if (response.status === 200) {
                    if (formData.elementsData.rememberMe)
                        setLocalStorage('sso_username', formData.elementsData.username);
                    postMessageLoggedIn();
                }
            });
        })
            .catch(() => {
            setNotificationCode(666);
            setLoading(false);
        });
    };
    const renderNotification = () => {
        switch (notificationCode) {
            case 0:
            case 200:
                return undefined;
            case 400:
                return /^[5][\d]{8}$/.test(username)
                    ? {
                        variant: 'error',
                        title: 'Er is helaas iets misgegaan',
                        children: _jsx(NotificationError, {}),
                    }
                    : {
                        variant: 'error',
                        title: 'Je inloggegevens kloppen helaas niet',
                        children: _jsx(NotificationIncorrectDetails, {}),
                    };
            case 429:
                return {
                    variant: 'error',
                    title: 'Je hebt het te vaak geprobeerd',
                    children: 'Om veiligheidsredenen ben je tijdelijk geblokkeerd. Probeer het over enkele minuten nog een keer.',
                };
            case 4001:
                return {
                    variant: 'error',
                    title: 'Dit inlogaccount is nog niet geactiveerd',
                    children: _jsx(NotificationNotActivated, { username: username }),
                };
            case 4003:
                return {
                    variant: 'error',
                    title: 'Dit inlogaccount is om administratieve redenen geblokkeerd',
                    children: 'Controleer je e-mail voor verdere uitleg en instructies.',
                };
            case 4007:
                return {
                    variant: 'warning',
                    title: 'Helaas is het niet mogelijk in te loggen met dit account',
                    children: _jsx(NotificationNoLongerPossible, {}),
                };
            default:
                return {
                    variant: 'warning',
                    title: 'Door een technische storing is het momenteel niet mogelijk om in te loggen',
                    children: 'Probeer het later opnieuw. Onze excuses voor het ongemak.',
                };
        }
    };
    return (_jsxs(LoginInContextContainer, { className: "SUGAR-sso-login-in-context", children: [_jsx(Panel, { hasOuterSpacing: false, children: _jsxs(Panel.Content, { children: [_jsxs(Form, { notification: renderNotification(), loading: loading, onSubmit: handleSubmit, children: [_jsxs(FormBlock, { label: "", children: [_jsx(FormFieldUsername, { reference: "username", name: "username", value: username, label: "Inlognaam" }), _jsx(FormFieldPassword, { label: "Wachtwoord", enableDisplayPassword: true }), _jsx(FormFieldCheckbox, { reference: "rememberMe", name: "rememberMe", value: "true", checked: !!getLocalStorage('sso_username', false), label: "Onthoud mijn inlognaam" })] }), _jsx(FormFooter, { children: _jsx(ButtonPrimary, { id: "btn_login", type: "submit", children: "Inloggen" }) })] }), _jsx(Typography, { variant: "body-text", children: _jsx(Link, { href: `https://${getParentWindowHost()}/login-vergeten`, target: "_parent", children: "Inloggegevens vergeten?" }) })] }) }), _jsxs(Panel, { hasOuterSpacing: false, variant: "featured", children: [_jsx(Panel.Header, { title: "Geen ANWB account?" }), _jsxs(Panel.Content, { children: [_jsx(Typography, { variant: "body-text", children: "Als u nog geen account heeft dan kunt u met uw relatienummer gemakkelijk een account aanmaken." }), _jsxs(List, { variant: "checked", children: [_jsx(ListItem, { children: "Persoonlijke gegevens inzien en wijzigen" }), _jsx(ListItem, { children: "Overzicht van producten en genoten ledenvoordeel" }), _jsx(ListItem, { children: "Toegang tot het ANWB Expertplatform" })] }), _jsx(Link, { href: `https://${getParentWindowHost()}/inlogaccount-aanmaken`, target: "_parent", children: "Account aanmaken" })] })] })] }));
};
export default LoginInContextApplication;
